import React from 'react';
import './Footer.css';

const Footer = ({ rightContent }) => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <p>&copy; {new Date().getFullYear()} Genpact. All rights reserved.</p>
        {rightContent && <div className="footer-right">{rightContent}</div>}
        <p className="footer-subtitle"></p>
      </div>
    </footer>
  );
};

export default Footer;

